import { ButtonLevel, ButtonStyle, ButtonType } from '@/shared/interfaces/button.interface';

export const UPDATES_REGISTRATION_STEPS = {
  identify: [
    {
      id: 'success',
      type: 'button',
      label: 'Yes, all good',
      class: 'btn-primary',
    },
    {
      id: 'about-your-hub',
      type: 'a',
      label: 'No, I still need help',
      class: 'btn-outline-primary',
    },
  ],
  networkErrors: {
    icon: 'frown',
    iconColor: '#5F2878',
    iconWeight: 'light',
    subtitle: 'Sorry, we can’t check for connection issues in your home right now',
    info: 'Please try again later or check out our help guide instead.',
    nextActions: [
      {
        uid: 'help',
        url: 'help',
        type: 'a',
        label: 'View our help guides',
        classes: 'button-tertiary-outline',
      },
    ],
  },
  registration: {
    networkErrors: {
      icon: 'FalFaceFrown',
      iconColor: '',
      iconWeight: 'light',
      subtitle: 'Sorry, there was an issue registering you for updates',
      info: 'Please try again later, and in the meantime check service status for updates.',
      nextActions: [
        {
          uid: 'return-to-service-status',
          url: '',
          type: ButtonType.BUTTON,
          label: 'Return to service status',
          buttonLevel: ButtonLevel.TERTIARY,
        },
      ],
    },
    success: {
      icon: 'FasCircleCheck',
      iconColor: 'success',
      iconWeight: 'solid',
      title: 'You’ll now receive updates on this issue',
      info: 'We’ll <text/email> you when thre’s an update on this issue.',
      nextActions: [
        {
          uid: 'return-to-service-status',
          url: './../../',
          type: ButtonType.BUTTON,
          label: 'Return to service status',
          buttonLevel: ButtonLevel.TERTIARY,
        },
      ],
    },
  },
  compensation: {
    networkErrors: {
      icon: 'FalFaceFrown',
      iconColor: '',
      iconWeight: 'light',
      subtitle: 'Sorry, there was an issue registering your loss of service',
      info: 'Please try again later or chat to our team who’ll help register this for you.',
      nextActions: [
        {
          type: ButtonType.CHAT,
          label: 'Chat to us online',
          buttonLevel: ButtonLevel.TERTIARY,
          chatId: 'faultsButton',
        },
        {
          uid: 'callUs',
          type: ButtonType.MODAL,
          label: 'Call us',
          buttonLevel: ButtonLevel.TERTIARY,
          buttonStyle: ButtonStyle.OUTLINE,
          chatId: '',
        },
      ],
      accessibilityText: 'Accessibility and extra support',
      accessibilityHref: '#',
    },
    success: {
      icon: 'check-circle',
      iconColor: 'success',
      title: 'Your loss of service has been registered',
      info:
        // eslint-disable-next-line max-len
        'We’re working to fix the issue, and once it’s fixed any credit owed will be applied to your bill. You can head to service status to sign up for issue updates',
      nextActions: [
        {
          uid: 'return-to-service-status',
          url: './../../',
          label: 'Return to service status',
          type: ButtonType.BUTTON,
          buttonLevel: ButtonLevel.TERTIARY,
        },
      ],
    },
  },
};

export const NOTIFICATION_RETURN_CODES = {
  outcomeMap: {
    error: 'API_ERROR',
    registrationSuccessful: 'NOTIFICATION_SUBSCRIPTION_REGISTER_SUCCESS',
    alreadyRegistered: 'NOTIFICATION_SUBSCRIPTION_ALREADY_REGISTERED',
  },
};

export const RETURN_CODES = {
  200: {
    notification: NOTIFICATION_RETURN_CODES.outcomeMap.registrationSuccessful,
    compensation: 'AUTOCOMPENSATION_REGISTER_SUCCESS',
  },
  208: {
    notification: NOTIFICATION_RETURN_CODES.outcomeMap.alreadyRegistered,
    compensation: 'AUTOCOMPENSATION_ALREADY_REGISTERED',
  },
  error: NOTIFICATION_RETURN_CODES.outcomeMap.error,
};
